import { dateTimeFormatter } from "./orders"

// export const baseUrl = "https://stage.techtonicretail.com/dark-store/"
const env = process.env.REACT_APP_ENV;  // "dev" or other
export const baseUrl = env === 'dev' 
    ? process.env.REACT_APP_STAGE_BACKEND_URL 
    : process.env.REACT_APP_LIVE_BACKEND_URL;

console.log('env and url ', process.env.REACT_APP_STAGE_BACKEND_URL, env);

export const regularExpression = {
  EMAIL_REGEX: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
  MOBILE_REGEX: /^[6-9]\d{9}$/,
  NAME_WITH_CHARACTERS_REGEX: /^[A-Za-z0-9&\s.]+$/,
  COMPANY_NAME_REGEX: /^[A-Za-z0-9&\s.]+$/,
  ADDRESS_REGEX: /^[a-zA-Z0-9\s.,-/]+$/,
  PINCODE_REGEX: /^[1-9][0-9]{5}$/,
  AMOUNTS_REGEX: /^\d+$/,
  PAN_REGEX: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
  IFSC_REGEX: /^[A-Z]{4}0[A-Z0-9]{6}$/,
  UPIID_REGEX: /[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{2,64}/,
  ACCOUNTNUMBER_REGEX: /^[0-9]{10,16}$/,
  GST_REGEX: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/,
  CIN_NO_REGEX: /^[A-Z][0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/,
  COMPANY_WEBSITE_REGEX: /^(https?:\/\/)?(www\.)?([A-Za-z0-9.-]+\.[A-Za-z]{2,})(\/[A-Za-z0-9-._~:/?#[\]@!$&'()*+,;:]*)?$/,
  ALPHA_NUMERIC_REGEX: /^[A-Za-z0-9 ]*$/,
  NUMERIC_DECIMAL_REGEX: /^\d+(\.\d+)?$/,
  DRIVER_LICENSE: /^[A-Za-z0-9]{6,10}$/,
  FLOORS_REGEX: /^[0-9a-zA-Z- ]+$/,
  INSURANCE_PERCENTAGE_REGEX: /^[0-9]+(\.[0-9]+)?$/
}

export const toastStyle = {
  style: {
    border: '1px solid #713200',
    padding: '16px',
    color: '#713200',
  },
  iconTheme: {
    primary: '#713200',
    secondary: '#FFFAEE',
  }
}

export const getMonthName = (monthNumber) => {
  const date = new Date();
  date.setMonth(monthNumber - 1); // Subtract 1 because months are zero-indexed
  return date.toLocaleString('default', { month: 'long' });
}


export const tableData = (data, page, limit) => {
  return (
    <>
      <table class="table mt-40">
        <thead>
          <tr>
            <th scope="col" className='order-th'><p>S. No.	</p></th>
            <th scope="col" className='order-th'><p>Order Number	</p></th>
            <th scope="col" className='order-th'><p>Date & Time</p></th>
            <th scope="col" className='order-th'><p>Total Price</p></th>
            <th scope="col" className='order-th'><p>Order Status</p></th>
            <th scope="col" className='order-th'><p>Billing Name</p></th>
            <th scope="col" className='order-th'><p>Shipping Address</p></th>
            <th scope="col" className='order-th'><p>LM Partner</p></th>
            <th scope="col" className='order-th'><p>Payment Mode</p></th>
            {/* <th scope="col" className='order-th'><p>Vinculum Status</p></th> */}
            {/* <th scope="col" className='order-th'>Action</th> */}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => (
            <tr key={item?.id}>
              <td><p>{(index + 1)+(page-1)*limit || (index + 1)}</p></td>
              <th><p className='order-id-color'>{item?.order_number}</p></th>
              <td><p>{dateTimeFormatter(item?.created_at)}</p></td>
              <td><p>Rs. {item?.total_price}</p></td>
              <td><p>{item?.order_status}</p></td>
              <td><p>{item?.billing_name}</p></td>
              <td><p>{item?.shipping_address1 + " ," + item?.shipping_city + " ," + item?.shipping_zip}</p></td>
              <td><p style={{ textTransform: "uppercase" }}>{item?.lm_partner || "--"}</p></td>
              <td><p style={{ textTransform: "uppercase" }}>{(item?.financial_status?.toLowerCase() === 'paid') ? "Prepaid" : (item?.financial_status?.toLowerCase() === 'pending') ? "COD" : "--"}</p></td>
              {/* <td><p>{item?.veniculum_status}</p></td> */}
              {/* <td><div className='pickup-action-btn'><button type="button" class="btn btn-primary"></button><i class="fa fa-ellipsis-h fa"></i></div></td> */}
            </tr>
          ))}
        </tbody>
      </table>
      {data?.length === 0 && (
        <div className='neworder-table-details'>
          <img src="https://app.shiprocket.in/seller/assets/images/no_data/no_orders_found.webp" />
        </div>
      )}
    </>
  )
}


const xxx = <html>
<body>
  <noscript>
    <a href="https://accounts.shopify.com/oauth/authorize?client_id=7ee65a63608843c577db8b23c4d7316ea0a01bd2f7594f8a9c06ea668c1b775c&amp;destination_uuid=fc4de6b2-7288-499e-8ef7-c399008a1991&amp;nonce=c0c1c682320a71888105180ac571dd41&amp;prompt=merge&amp;redirect_uri=https%3A%2F%2F2ebb91-32.myshopify.com%2Fadmin%2Fauth%2Fidentity%2Fcallback&amp;response_type=code&amp;scope=email%20https%3A%2F%2Fapi.shopify.com%2Fauth%2Fdestinations.readonly%20openid%20profile%20https%3A%2F%2Fapi.shopify.com%2Fauth%2Fpartners.collaborator-relationships.readonly%20https%3A%2F%2Fapi.shopify.com%2Fauth%2Fbanking.manage%20https%3A%2F%2Fapi.shopify.com%2Fauth%2Fmerchant-setup-dashboard.graphql%20https%3A%2F%2Fapi.shopify.com%2Fauth%2Fshopify-chat.admin.graphql%20https%3A%2F%2Fapi.shopify.com%2Fauth%2Fflow.workflows.manage%20https%3A%2F%2Fapi.shopify.com%2Fauth%2Forganization-identity.manage%20https%3A%2F%2Fapi.shopify.com%2Fauth%2Fmerchant-bank-account.manage%20https%3A%2F%2Fapi.shopify.com%2Fauth%2Fshopify-tax.manage&amp;state=6be7696fd129c298e77ae4760949a184&amp;ui_locales=en&amp;ux=shop">Continue</a>
  </noscript>

  <script type="text/javascript" defer>
    window.location = "https:\/\/accounts.shopify.com\/oauth\/authorize?client_id=7ee65a63608843c577db8b23c4d7316ea0a01bd2f7594f8a9c06ea668c1b775c\u0026destination_uuid=fc4de6b2-7288-499e-8ef7-c399008a1991\u0026nonce=c0c1c682320a71888105180ac571dd41\u0026prompt=merge\u0026redirect_uri=https%3A%2F%2F2ebb91-32.myshopify.com%2Fadmin%2Fauth%2Fidentity%2Fcallback\u0026response_type=code\u0026scope=email%20https%3A%2F%2Fapi.shopify.com%2Fauth%2Fdestinations.readonly%20openid%20profile%20https%3A%2F%2Fapi.shopify.com%2Fauth%2Fpartners.collaborator-relationships.readonly%20https%3A%2F%2Fapi.shopify.com%2Fauth%2Fbanking.manage%20https%3A%2F%2Fapi.shopify.com%2Fauth%2Fmerchant-setup-dashboard.graphql%20https%3A%2F%2Fapi.shopify.com%2Fauth%2Fshopify-chat.admin.graphql%20https%3A%2F%2Fapi.shopify.com%2Fauth%2Fflow.workflows.manage%20https%3A%2F%2Fapi.shopify.com%2Fauth%2Forganization-identity.manage%20https%3A%2F%2Fapi.shopify.com%2Fauth%2Fmerchant-bank-account.manage%20https%3A%2F%2Fapi.shopify.com%2Fauth%2Fshopify-tax.manage\u0026state=6be7696fd129c298e77ae4760949a184\u0026ui_locales=en\u0026ux=shop";
  </script>
</body>
</html>
